import { css } from '@microsoft/fast-element';
import { cornerRadiusControl, elevationCardHover, strokeThickness } from '@adaptive-web/adaptive-ui/reference';
import { componentBaseStyles } from '@adaptive-web/adaptive-ui';
import { PropertyStyleSheetBehavior } from '@microsoft/fast-foundation';

export default css`
	${componentBaseStyles}

	:host {
		container: header / inline-size;
		display: grid;
		grid-template-columns: minmax(0, 8fr);
		border-bottom: ${strokeThickness} solid transparent;
		position: sticky;
		top: 0;
		z-index: 10;
	}

	[part=positioning-region] {
    max-width: var(--max-content-width);
    width: 100%;
    margin: 0 auto;
    padding: var(--padding-sm) var(--padding-md);
    display: flex;
    justify-content: space-between;
		align-items: center;
	}

	a {
		grid-row: 1;
		justify-self: flex-start;
		border-radius: ${cornerRadiusControl};

		> span {
			display: flex;
			justify-content: flex-start;

			> svg {
				height: 70px;
			}
		}
	}

	nav {
		display: flex;
		grid-row: 1;
		justify-self: flex-end;
	}

	.backdrop {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 100%;
		z-index: -1;
	}

	@media (max-height: 490px) {
		:host {
			position: unset;
		}
	}
`.withBehaviors(
	new PropertyStyleSheetBehavior(
		'view',
		'scroll',
		css`
			:host, :host::before, :host::after {
				background-color: rgba(255, 255, 255, 0.9);
				transition: 200ms ease-in-out;
			}

			.backdrop {
				box-shadow: ${elevationCardHover};
				backdrop-filter: blur(8px);
				-webkit-backdrop-filter: blur(8px);
			}

			.logo-white {
				display: none;
			}

			a:is(:focus-visible, :focus) {
				outline: #22303D solid 2px;
			}
		`
	),
	new PropertyStyleSheetBehavior(
		'view',
		'default',
		css`
			:host {
				background-color: var(--primary-color);
				transition: 200ms ease-in-out;
			}

			.logo-color {
				display: none;
			}

			a:is(:focus-visible, :focus) {
				outline: #ffffff solid 2px;
			}
		`
	)
)